<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title">{{mode !== 'shipping' ? 'change_address' : 'change_shipping_address' | translate}}</h4>
        </div>
        <div class="modal-body" v-if="mode === 'shipping'">
          <div class="row">
            <div class="col-xs-8">
              <h5>{{address.delivery_first_name}} {{address.delivery_last_name}}</h5>
              <p>{{address.delivery_address_line_1}}
                <template v-if="address.delivery_address_line_2 != ''">
                  <br/>
                  {{address.delivery_address_line_2}}
                </template>
                <template v-if="address.delivery_address_line_3 != ''">
                  <br/>
                  {{address.delivery_address_line_3}}
                </template><br>{{address.delivery_zip_code}}, {{address.delivery_city}}<br>{{address.delivery_country | country}}</p>
            </div>
            <div class="col-xs-4">
              <select class="form-control" v-model="addressType">
                <option class="normal" value="hausadresse">{{'home_address' | translate}}</option>
                <option class="normal" value="packstation">{{'packstation' | translate}}</option>
                <option class="normal" value="postfiliale">{{'post_store' | translate}}</option>
              </select>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="form-group col-sm-6 col-xs-12">
              <label class="pull-left">{{'first_name' | translate}}*</label>
              <input v-validate="''" data-vv-as="First Name" class="form-control" name="corrected_first_name" placeholder="First Name" type="text" v-model="address.corrected_first_name">
              <span v-show="errors.has('corrected_first_name')" class="small text-danger">{{ errors.first('corrected_first_name') }}</span>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label class="pull-left">{{'last_name' | translate}}*</label>
              <input v-validate="''" data-vv-as="Last Name" class="form-control" name="corrected_last_name" placeholder="Last Name" type="text" v-model="address.corrected_last_name">
              <span v-show="errors.has('corrected_last_name')" class="small text-danger">{{ errors.first('corrected_last_name') }}</span>
            </div>
          </div>
          <div class="row" v-if="addressType === 'hausadresse'">
            <div class="form-group col-sm-10 col-xs-12">
              <label class="pull-left">{{'street' | translate}}*</label>
              <input v-validate="''" data-vv-as="Street" class="form-control" name="corrected_street" placeholder="Street" type="text" v-model="address.corrected_street">
              <span v-show="errors.has('corrected_street')" class="small text-danger">{{ errors.first('corrected_street') }}</span>
            </div>
            <div class="form-group col-sm-2 col-xs-12">
              <label class="pull-left">{{'shipping_street_no' | translate}}*</label>
              <input v-validate="''" data-vv-as="Street No." class="form-control" name="corrected_street_number" placeholder="Nr." type="text" v-model="address.corrected_street_number">
              <span v-show="errors.has('corrected_street_number')" class="small text-danger">{{ errors.first('corrected_street_number') }}</span>
            </div>
          </div>
          <div class="row" v-else>
            <div class="form-group col-sm-10 col-xs-12 hidden">
              <label class="pull-left">{{'street' | translate}}*</label>
              <input class="form-control" name="corrected_street" placeholder="Street" type="text" v-model="address.corrected_street">
            </div>
            <div class="form-group col-sm-12 col-xs-12">
              <label class="pull-left">{{getLabel() | translate}}:</label>
              <input v-validate="''" data-vv-as="Street No." class="form-control" name="corrected_street_number" placeholder="Care of" type="text" v-model="address.corrected_street_number">
              <span v-show="errors.has('corrected_street_number')" class="small text-danger">{{ errors.first('corrected_street_number') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-6 col-xs-12" v-if="addressType === 'hausadresse'">
              <label class="pull-left">{{'company' | translate}}:</label>
              <input v-validate="''" data-vv-as="Company" class="form-control" name="corrected_company" placeholder="Company" type="text" v-model="address.corrected_company">
              <span v-show="errors.has('corrected_company')" class="small text-danger">{{ errors.first('corrected_company') }}</span>
            </div>
            <div :class="['form-group', 'col-xs-12', addressType === 'hausadresse' ? 'col-sm-6' : '']">
              <label class="pull-left">Postnummer*</label>
              <input v-validate="''" data-vv-as="Care of" class="form-control" name="corrected_care_of" placeholder="Nr." type="text" v-model="address.corrected_care_of">
              <span v-show="errors.has('corrected_care_of')" class="small text-danger">{{ errors.first('corrected_care_of') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-4 col-xs-12">
              <label class="pull-left">{{'zip_code' | translate}}:</label>
              <input v-validate="''" data-vv-as="ZIP code" class="form-control" name="corrected_zip" placeholder="ZIP" type="text" v-model="address.corrected_zip">
              <span v-show="errors.has('corrected_zip')" class="small text-danger">{{ errors.first('corrected_zip') }}</span>
            </div>
            <div class="form-group col-sm-8 col-xs-12">
              <label class="pull-left">{{'city' | translate}}:</label>
              <input v-validate="''" data-vv-as="City" class="form-control" name="corrected_city" placeholder="City" type="text" v-model="address.corrected_city">
              <span v-show="errors.has('corrected_city')" class="small text-danger">{{ errors.first('corrected_city') }}</span>
            </div>
          </div>
        </div>
        <div class="modal-body" v-else>
          <div class="row">
            <div class="col-xs-12">
              <h5>{{billing.billing_first_name}} {{billing.billing_last_name}}</h5>
              <p>{{address.billing_address_line_1}}
                <template v-if="billing.billing_address_line_2 != ''">
                  <br/>
                  {{billing.billing_address_line_2}}
                </template>
                <template v-if="billing.billing_address_line_3 != ''">
                  <br/>
                  {{billing.billing_address_line_3}}
                </template><br>{{billing.billing_zip_code}}, {{billing.billing_city}}<br>{{billing.billing_country | country}}</p>
              <hr>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-6 col-xs-12">
              <label class="pull-left" for="billing_first_name">{{'first_name' | translate}} *</label>
              <input v-validate="''" data-vv-as="First Name" class="form-control" name="billing_first_name" placeholder="First Name" type="text" v-model="address.billing_first_name">
              <span v-show="errors.has('billing_first_name')" class="small text-danger">{{ errors.first('billing_first_name') }}</span>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label class="pull-left" for="billing_last_name">{{'last_name' | translate}} *</label>
              <input v-validate="''" data-vv-as="Last Name" class="form-control" name="corrected_last_name" placeholder="Last Name" type="text" v-model="address.billing_last_name">
              <span v-show="errors.has('billing_last_name')" class="small text-danger">{{ errors.first('billing_last_name') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-xs-12">
              <label for="billing_address_line_1" class="pull-left">Address Line 1 *</label>
              <input v-validate="''" data-vv-as="Address line 1" class="form-control" name="billing_address_line_1" placeholder="Address Line 1" type="text" v-model="address.billing_address_line_1">
              <span v-show="errors.has('billing_address_line_1')" class="small text-danger">{{ errors.first('corrected_street') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-xs-12">
              <label for="billing_address_line_2" class="pull-left">Address line 2</label>
              <input v-validate="''" data-vv-as="Address line 2" class="form-control" name="billing_address_line_2" placeholder="Address Line 2" type="text" v-model="address.billing_address_line_2">
              <span v-show="errors.has('billing_address_line_2')" class="small text-danger">{{ errors.first('billing_address_line_2') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-xs-12">
              <label for="billing_address_line_3" class="pull-left">Address line 3</label>
              <input v-validate="''" data-vv-as="Address line 3" class="form-control" name="billing_address_line_3" placeholder="Address Line 3" type="text" v-model="address.billing_address_line_3">
              <span v-show="errors.has('billing_address_line_3')" class="small text-danger">{{ errors.first('billing_address_line_3') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-4 col-xs-12">
              <label for="billing_zip_code" class="pull-left">{{'zip_code' | translate}}:</label>
              <input v-validate="''" data-vv-as="ZIP code" class="form-control" name="billing_zip_code" placeholder="ZIP" type="text" v-model="address.billing_zip_code">
              <span v-show="errors.has('billing_zip_code')" class="small text-danger">{{ errors.first('billing_zip_code') }}</span>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label for="billing_city" class="pull-left">{{'city' | translate}}:</label>
              <input v-validate="''" data-vv-as="City" class="form-control" name="billing_city" placeholder="City" type="text" v-model="address.billing_city">
              <span v-show="errors.has('billing_city')" class="small text-danger">{{ errors.first('billing_city') }}</span>
            </div>
            <div class="form-group col-sm-2 col-xs-12">
              <label for="billing_country" class="pull-left">{{'country' | translate}}:</label>
              <input v-validate="''" data-vv-as="Country" class="form-control" name="billing_country" placeholder="Country" type="text" v-model="address.billing_country">
              <span v-show="errors.has('billing_country')" class="small text-danger">{{ errors.first('billing_country') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-xs-12">
              <label for="customer_email" class="pull-left">{{'email' | translate}}:</label>
              <input v-validate="'email'" data-vv-as="email" class="form-control" name="customer_email" placeholder="email" type="text" v-model="address.customer_email">
              <span v-show="errors.has('customer_email')" class="small text-danger">{{ errors.first('customer_email') }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModal" @click="address = JSON.parse(JSON.stringify(addressForComp))" class="btn btn-app btn-outline no-margin pull-left" data-dismiss="modal"><span class="fa fa-times"></span>{{'cancel' | translate}}</button>
          <button type="button" id="confirmEdit" :disabled="errors.any()" class="btn btn-app btn-success" @click="send()"><span class="fa fa-save "></span>{{'edit' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    addressForComp: {
      type: Object
    },
    id: {
      type: String,
      default: 'edit-modal'
    },
    mode: {
      type: String
    },
    line: {
      type: Number
    }
  },
  data () {
    return {
    	address: {},
        billing: {
          billing_first_name: '',
          billing_last_name: '',
          billing_address_line_1: '',
          billing_address_line_2: '',
          billing_address_line_3: '',
          billing_zip_code: '',
          billing_city: '',
          billing_country: ''
        },
        addressType: ''
    }
  },
  methods: {
    getLabel () {
      return this.addressType === 'postfiliale' ? 'post_store' : this.addressType === 'hausadresse' ? 'care_of' : 'packstation'
    },
    send () {
      let id = typeof this.$parent.order === 'undefined' ? this.$parent.editOrderId : this.$parent.order.id
      if (this.addressType !== 'hausadresse') {
        this.address.corrected_street = this.addressType
        this.address.corrected_company = ''
      }
      API.put(`orders/${id}/customer/${this.mode}`, this.address)
        .then(response => {
          $(`#${this.id}`).modal('hide')
          this.$emit('alert', response)
        })
        .catch(error => {
          $(`#${this.id}`).modal('hide')
          this.$emit('alert', error)
        })
    }
  },
  mounted () {
  },
  watch: {
	  addressForComp () {
	  	this.address = JSON.parse(JSON.stringify(this.addressForComp))
      this.addressType = this.address.corrected_street === 'packstation' || this.address.corrected_street === 'postfiliale' ? this.address.corrected_street : 'hausadresse'
      this.address.corrected_city = this.address.corrected_city === '' ? this.address.delivery_city : this.address.corrected_city
      this.address.corrected_first_name = this.address.corrected_first_name === '' ? this.address.delivery_first_name : this.address.corrected_first_name
      this.address.corrected_last_name = this.address.corrected_last_name === '' ? this.address.delivery_last_name : this.address.corrected_last_name
      this.address.corrected_zip = this.address.corrected_zip === '' ? this.address.delivery_zip_code : this.address.corrected_zip
      this.billing.billing_first_name = this.address.billing_first_name
      this.billing.billing_last_name = this.address.billing_last_name
      this.billing.billing_country = this.address.billing_country
      this.billing.billing_city = this.address.billing_city
      this.billing.billing_zip_code = this.address.billing_zip_code
      this.billing.billing_address_line_1 = this.address.billing_address_line_1
      this.billing.billing_address_line_2 = this.address.billing_address_line_2
      this.billing.billing_address_line_3 = this.address.billing_address_line_3
      this.billing.customer_email = this.address.customer_email
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/EditAddressModal.vue